import { AliceServiceRequestResource } from "./resources";

export function requestService({
  propertyId,
  room,
  lastname,
  from,
  to,
  dueTime,
  serviceId,
  serviceMessage,
}) {
  return new Promise((resolve, reject) => {
    AliceServiceRequestResource.save(
      {},
      {
        propertyId,
        room,
        lastname,
        from,
        to,
        dueTime,
        serviceId,
        serviceMessage,
      }
    ).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
